// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__U6-Jo","additionalInfo":"AgreementModal_additionalInfo__2yq1L"};